import type { QuickBooksSyncJobPayload } from '@ankor-io/common/types/integrations/quickbooks'
import type { XeroSyncJobPayload } from '@ankor-io/common/types/integrations/xero/types'

export type SyncJobRow = {
  id: string
  status: string
  connectedAccountName: string
  accountName: string
  startedAt: string
  duration?: number
  lastRun?: { id: string; status: string }
}

export function mapXeroSyncJob(job: XeroSyncJobPayload): SyncJobRow {
  return {
    id: job.id,
    status: job.status,
    connectedAccountName: job.connectedAccountName,
    accountName: job.tenantName,
    startedAt: job.startedAt,
    duration: job.duration,
    lastRun: job.lastRun ? { id: job.lastRun.id, status: job.lastRun.status } : undefined,
  }
}

export function mapQuickBooksSyncJob(job: QuickBooksSyncJobPayload): SyncJobRow {
  return {
    id: job.id,
    status: job.status,
    connectedAccountName: job.connectedAccountName,
    accountName: job.companyName,
    startedAt: job.startedAt,
    duration: job.duration,
    lastRun: job.lastRun ? { id: job.lastRun.id, status: job.lastRun.status } : undefined,
  }
}
